// extracted by mini-css-extract-plugin
export default {"menu-item":"styles_menu-item__pkxwT"};